import { Unlocked as UnlockIcon } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { FunctionalModal } from 'component/modal/functional-modal';
import { t } from 'util/stdtypes';

export function ReopenSpaceModal({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) {
    const { colors } = useTheme();
    return (
        <FunctionalModal
            headingLabel={t('question.actions.reopen_modal_heading', 'Re-open this space?')}
            onClose={onClose}
            primaryButton={{
                label: t('question.actions.reopen_confirm_button', 'Re-open'),
                icon: <UnlockIcon color={colors.colorTextWarning} />,
                type: 'delete',
                onPress: onConfirm,
            }}
            secondaryButton={{
                label: t('modal.cancel_button', 'Cancel'),
                onPress: onClose,
            }}
            subheadingLabel={t('question.actions.reopen_modal_description', 'Re-open this space to make the conversation active again.')}
        />
    );
}
